import request from "@/service";

/* 查询原创文章列表 */
export function articleList(data) {
  return request({
    url: "/resource/original/article/page",
    method: "get",
    params: data
  });
}

/* 批量删除原创文章 */
export function articleDelete(data) {
  return request({
    url: "/resource/original/article/delete",
    method: "delete",
    data
  });
}

// 获取原创文章详情
export function articleDetail(id) {
  return request({
    url: `/resource/original/article/info/${id}`,
    method: "get"
  });
}

/* 批量上下线原创文章 */
export function articleOnline(data) {
  return request({
    url: "/resource/original/article/online",
    method: "put",
    data
  });
}
